export const IMAGES = {
  maersk:    "/Maersk_Logo2-80x80.png",
  msc:       "/msc-80x80.png",
  cmaCgm:    "/cma-cgm2-80x80.png",
  hapagLloyd:"/hapag-lloyd-2-logo-png-transparent-80x80.png",
  one:       "/one_line_logo-80x80.png",
  hmm:       "/hmm-logo-80x80.png",
  yangMing:  "/yang-ming-marine-80x80.png",
  wanHai:    "/wanhai-80x80.png",
  zim:       "/zim-logo-80x80.png",
  matson:    "/matson_logo2-80x80.png",
  pil:       "/pil-logo2-80x80.png",
  triton:    "/triton_logo-80x80.png",
  emc:       "/emc_logo-80x80.png",
};
